import React from "react"
import { Link } from "rebass"
import { css, keyframes } from "@emotion/core"

import { DownArrow } from "./down-arrow"

const bounce = keyframes`
  0% {
    transform: translateY(-8px);
  }

  50% {
    transform: translateY(-4px);
  }

  100% {
    transform: translateY(-8px);
  }
`

export const ArrowLink = ({ href }) => (
  <Link
    href={`#${href}`}
    css={css`
      animation-name: ${bounce};
      animation-duration: 1.3s;
      animation-delay: 0s;
      animation-timing-function: ease-out, ease-in-out;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-direction: normal, alternate;
    `}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 24,
      opacity: 0.5,
      appearance: "none",
      padding: 0,
      borderRadius: "100%",
      border: "1px solid",
      borderColor: "#fffdba",
      background: "transparent",
      boxShadow: "none",
      width: 36,
      height: 36,
      transition: "opacity .2s ease-out",
      "&:hover": {
        opacity: 1,
      },
    }}
  >
    <DownArrow />
  </Link>
)
